import { render, staticRenderFns } from "./form_new.vue?vue&type=template&id=8667644a&"
import script from "./form_new.vue?vue&type=script&lang=js&"
export * from "./form_new.vue?vue&type=script&lang=js&"
import style0 from "./form_new.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8667644a')) {
      api.createRecord('8667644a', component.options)
    } else {
      api.reload('8667644a', component.options)
    }
    module.hot.accept("./form_new.vue?vue&type=template&id=8667644a&", function () {
      api.rerender('8667644a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_new.vue"
export default component.exports